import logoSvg from '../assets/ELeFANT_branded_logo.svg?raw'
import './ProductLogo.css'

// Inline the supplied SVG so its paths can use the application's theme colors.
const productLogoMarkup = logoSvg.slice(logoSvg.indexOf('<svg'))

export default function ProductLogo({ className = '' }) {
  return (
    <span
      className={`product-logo${className ? ` ${className}` : ''}`}
      role="img"
      aria-label="ELeFANT by Swissbit"
      data-i18n-skip="1"
      dangerouslySetInnerHTML={{ __html: productLogoMarkup }}
    />
  )
}
